import {h, resolveComponent} from 'vue'
import {createRouter, createWebHashHistory} from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'
import store from "@/store";
import {config} from "@/config";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: DefaultLayout,
        redirect: '/panel',
        children: [
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: () =>
                    import(/* webpackChunkName: "dashboard" */ '@/views/windows/apps/Directorio.vue'),
            },
            {
                name: 'Panel',
                path: '/panel',
                component: () => import('@/views/windows/tareas/PanelProductos.vue'),
            },
            {
                name: 'Ver noticia',
                path: '/ver/noticia/:id?',
                component: () => import('@/views/windows/paginas/VerPost.vue'),
            },
            {
                name: 'Ver listado',
                path: '/ver/noticias',
                component: () => import('@/views/windows/paginas/VerListadoPublico.vue'),
            },
            {
                name: 'Ver ayuda',
                path: '/ver/ayuda-p/:id?',
                component: () => import('@/views/windows/paginas/VerPostAyuda.vue'),
            },
            {
                name: 'Ver listado ayuda',
                path: '/ver/ayuda',
                component: () => import('@/views/windows/paginas/VerListadoPublicoAyuda.vue'),
            }

        ],
    },
    {
        path: '/admin',
        name: 'Administración',
        component: DefaultLayout,
        redirect: '',
        children: [
            {
                name: 'Tareas',
                path: '/admin/tareas',
                component: () => import('@/views/windows/tareas/ListadoTareas.vue'),
                meta: { access: 'tareas/mis-tareas' },
            },
            {
                name: 'Listado de tareas',
                path: '/admin/tareas/:pr',
                component: () => import('@/views/windows/tareas/ListadoTareas.vue'),
                meta: { access: 'tareas/mis-tareas' },
            },
            {
                name: 'Listado de tareas por lote',
                path: '/admin/tareas/lote',
                component: () => import('@/views/windows/tareas/ListadoTareasLote.vue'),
                meta: { access: 'tareas/mis-tareas/lote' },
            },
            {
                name: 'Listado de mis tareas',
                path: '/admin/tareas/asignadas',
                component: () => import('@/views/windows/tareas/ListadoMisTareas.vue'),
                meta: { access: 'tareas/mis-tareas-asignadas' },
            },
            {
                name: 'Flujo',
                path: '/solicitar/producto/:tokenProducto/:tokenCotizacion',
                component: () => import('@/views/windows/tareas/CotizarProducto.vue'),
            },
            {
                name: 'Crear tarea',
                path: '/admin/tareas/edit/:id',
                component: () => import('@/views/windows/tareas/Editar.vue'),
                meta: { access: 'tareas/mis-tareas' },
            },
            {
                name: 'Plantillas de tarea',
                path: '/admin/tareas-templates',
                component: () => import('@/views/windows/tareas/TemplatesListado.vue'),
                meta: { access: 'users/role/admin' },
            },
            {
                name: 'Crear plantilla',
                path: '/admin/tareas-templates/edit/:id',
                component: () => import('@/views/windows/tareas/TemplatesEditar.vue'),
                meta: { access: 'users/role/admin' },
            },
            {
                name: 'Archivadores Listado',
                path: '/admin/archivadores',
                component: () => import('@/views/windows/archivadores/Listado.vue'),
                meta: { access: 'admin/archivadores' },
            },
            {
                name: 'Editar archivador',
                path: '/admin/archivador/edit/:id',
                component: () => import('@/views/windows/archivadores/Editar.vue'),
                meta: { access: 'admin/archivadores' },
            },
            {
                name: 'Formularios Listado',
                path: '/admin/formularios',
                component: () => import('@/views/windows/formularios/Listado.vue'),
                meta: { access: 'users/role/admin' },
            },
            {
                name: 'Productos Listado',
                path: '/admin/productos',
                component: () => import('@/views/windows/productos/Listado.vue'),
                meta: { access: 'users/role/admin' },
            },
            {
                name: 'Editar producto',
                path: '/admin/productos/edit/:id',
                component: () => import('@/views/windows/productos/Editar.vue'),
                meta: { access: 'users/role/admin' },
            },
            {
                name: 'Editar formulario',
                path: '/admin/formulario/edit/:id',
                component: () => import('@/views/windows/formularios/Editar.vue'),
                meta: { access: 'users/role/admin' },
            },
            {
                name: 'Productos',
                path: '/admin/flujos',
                component: () => import('@/views/windows/flujos/Listado.vue'),
                meta: { access: 'admin/flujos' },
            },
            {
                name: 'Productos Habilitar',
                path: '/admin/mis-flujos/activar',
                component: () => import('@/views/windows/flujos/ListadoActivo.vue'),
                meta: { access: 'admin/mis-flujos/activar' },
            },
            {
                name: 'Editar página',
                path: '/admin/blog/editar/:id?',
                component: () => import('@/views/windows/paginas/Editar.vue'),
                meta: { access: 'paginas/admin/noti' },
            },
            {
                name: 'Listado de páginas',
                path: '/admin/blog/list',
                component: () => import('@/views/windows/paginas/Listado.vue'),
                meta: { access: 'paginas/admin/noti' },
            },
            {
                name: 'Editar página de ayuda',
                path: '/admin/ayuda/editar/:id?',
                component: () => import('@/views/windows/paginas/EditarAyuda.vue'),
                meta: { access: 'paginas/admin/ayuda' },
            },
            {
                name: 'Listado de páginas ayuda',
                path: '/admin/ayuda/list',
                component: () => import('@/views/windows/paginas/ListadoAyuda.vue'),
                meta: { access: 'paginas/admin/ayuda' },
            },
            {
                name: 'Blog Listado',
                path: '/ver/noticias/listado',
                component: () => import('@/views/windows/paginas/Listado.vue'),
                meta: { access: 'paginas/admin/noti' },
            },

            {
                name: 'Editar producto',
                path: '/admin/flujo/edit/:id',
                component: () => import('@/views/windows/flujos/Editar.vue'),
                meta: { access: 'admin/flujos' },
            },
            {
                name: 'Editar plantilla PDF',
                path: '/admin/plantillas-pdf/:id',
                component: () => import('@/views/windows/tareas/PlantillasPdfEditar.vue'),
                meta: { access: 'admin/plantillas-pdf' },
            },
            {
                name: 'Listado de plantillas PDF',
                path: '/admin/plantillas-pdf',
                component: () => import('@/views/windows/tareas/PlantillasPdfListado.vue'),
                meta: { access: 'admin/plantillas-pdf' },
            },
            {
                name: 'Variables de sistema',
                path: '/admin/system-vars',
                component: () => import('@/views/windows/configuracion/VariablesSistema.vue'),
                meta: { access: 'admin/system-vars' },
            },
            {
                name: 'Orden de ventana por lotes',
                path: '/admin/ventana-lote',
                component: () => import('@/views/windows/configuracion/OrdenVentanaLotes.vue'),
                meta: { access: 'admin/orden_ventana_lote' },
            },
            {
                name: 'Configuración de OCR',
                path: '/admin/ocr_config',
                component: () => import('@/views/windows/ocr/OcrListado.vue'),
                meta: { access: 'admin/ocr_config' },
            },
            {
                name: 'Edición de OCR',
                path: '/admin/ocr_config/:id',
                component: () => import('@/views/windows/ocr/OcrEditar.vue'),
                meta: { access: 'admin/ocr_config' },
            },
            {
                name: 'Mantenimiento',
                path: '/admin/campos',
                component: () => import('@/views/windows/configuracion/MantenimientoTareas.vue'),
                meta: { access: 'mantenimiento/campos' },
            },
            {
                name: 'Mantenimiento campos',
                path: '/admin/campos-tarea/:id',
                component: () => import('@/views/windows/configuracion/MantenimientoCampos.vue'),
                meta: { access: 'mantenimiento/campos' },
            },
            {
                name: 'Sistema',
                path: '/admin/system',
                component: () => import('@/views/windows/configuracion/Sistema.vue'),
                meta: { access: 'mantenimiento/campos' },
            },
            {
                name: 'Personalización',
                path: '/admin/personalizacion',
                component: () => import('@/views/windows/configuracion/Personalizacion.vue'),
                meta: { access: 'admin/personalizacion' },
            },
            {
                name: 'Servicios por lotes',
                path: '/admin/ws_lote',
                component: () => import('@/views/windows/configuracion/wsLotes.vue'),
                meta: { access: 'mantenimiento/campos' },
            },
            {
                name: 'Vistas agrupadas',
                path: '/admin/vista_agrupada',
                component: () => import('@/views/windows/configuracion/VistaAgrupadaListado.vue'),
                meta: { access: 'admin/vista_agrupada' },
            },
            {
                name: 'Edición de vista agrupada',
                path: '/admin/vista_agrupada/:id',
                component: () => import('@/views/windows/configuracion/VistaAgrupadaEditar.vue'),
                meta: { access: 'admin/vista_agrupada' },
            },
            {
                name: 'Visualizacion agrupada',
                path: '/tarea/agrupada',
                component: () => import('@/views/windows/configuracion/VistaAgrupadaVer.vue'),
                meta: { access: 'tarea/agrupada' },
            },
        ],
    },
    {
        path: '/usuarios',
        name: 'Usuarios',
        component: DefaultLayout,
        redirect: '/usuarios/listado',
        children: [
            {
                name: 'Listado usuarios',
                path: '/usuarios/listado',
                component: () => import('@/views/windows/usuarios/UsuariosListado.vue'),
                meta: { access: 'users/admin' },
            },
            {
                name: 'Editar usuario',
                path: '/usuarios/edit/:id',
                component: () => import('@/views/windows/usuarios/UsuariosEditar.vue'),
                meta: { access: 'users/admin' },
            },
            {
                name: 'Listado roles',
                path: '/usuarios/roles/listado',
                component: () => import('@/views/windows/usuarios/RolesListado.vue'),
                meta: { access: 'users/role/admin' },
            },
            {
                name: 'Editar rol',
                path: '/usuarios/roles/edit/:id',
                component: () => import('@/views/windows/usuarios/RolesEditar.vue'),
                meta: { access: 'users/role/admin' },
            },
            {
                name: 'Canales de usuarios',
                path: '/usuarios/canal/listado',
                component: () => import('@/views/windows/usuarios/CanalUsuarioListado.vue'),
                meta: { access: 'users/admin/grupos' },
            },
            {
                name: 'Editar canal',
                path: '/usuarios/canal/edit/:id',
                component: () => import('@/views/windows/usuarios/CanalUsuarioEditar.vue'),
                meta: { access: 'users/admin/grupos' },
            },
            {
                name: 'Grupos de usuarios',
                path: '/usuarios/grupo/listado',
                component: () => import('@/views/windows/usuarios/GruposUsuarioListado.vue'),
                meta: { access: 'users/admin/grupos' },
            },
            {
                name: 'Editar grupo',
                path: '/usuarios/grupo/edit/:id',
                component: () => import('@/views/windows/usuarios/UsuariosGrupoEditar.vue'),
                meta: { access: 'users/admin/grupos' },
            },
            {
                name: 'Jerarquias de usuario',
                path: '/usuarios/jerarquia/listado',
                component: () => import('@/views/windows/usuarios/UsuarioJerarquiaListado.vue'),
                meta: { access: 'users/jerarquia/admin' },
            },
            {
                name: 'Jerarquias editar',
                path: '/usuarios/jerarquia/edit/:id',
                component: () => import('@/views/windows/usuarios/UsuarioJerarquiaEditar.vue'),
                meta: { access: 'users/jerarquia/admin' },
            },
            {
                name: 'Asociación masiva',
                path: '/usuarios/asociacion-masiva',
                component: () => import('@/views/windows/usuarios/AsociacionMasiva.vue'),
                meta: { access: 'users/admin' },
            },
        ],
    },
    {
        path: '/reportes',
        name: 'Reportes',
        component: DefaultLayout,
        redirect: '/reportes/configuracion',
        children: [
            {
                name: 'Configuración de reportes',
                path: '/reportes/configuracion',
                component: () => import('@/views/windows/reportes/Listado.vue'),
                meta: { access: 'reportes/admin' },
            },
            {
                name: 'Editar reporte',
                path: '/reportes/configuracion/:id',
                component: () => import('@/views/windows/reportes/Editar.vue'),
                meta: { access: 'reportes/admin' },
            },
            {
                name: 'Generar reporte',
                path: '/reportes/generar',
                component: () => import('@/views/windows/reportes/Generar.vue'),
                meta: { access: 'reportes/generar' },
            },
            {
                name: 'Reportes masivos',
                path: '/reportes/masivo',
                component: () => import('@/views/windows/reportes/ListadoMasivo.vue'),
                meta: { access: 'reportes/masivo' },
            },
        ],
    },
    {
        path: '/configuration',
        name: 'Configuración',
        component: DefaultLayout,
        redirect: '/configuration/system',
        children: [
            {
                name: 'Configuración de sistema',
                path: '/configuration/sistema',
                component: () => import('@/views/windows/configuracion/NotificacionEditar.vue'),
                meta: { access: 'mantenimiento/campos' },
            },
        ],
    },
    {
        path: '/',
        redirect: '/404',
        component: {
            render() {
                return h(resolveComponent('router-view'))
            },
        },
        children: [
            {
                path: '/404',
                name: 'Page404',
                component: () => import('@/views/pages/Page404'),
                meta: {
                    public: true
                }
            },
            {
                path: '/f/:tokenProducto/:tokenCotizacion',
                name: 'Formulario',
                component: () => import('@/views/pages/Formularios.vue'),
                meta: {
                    public: true
                }
            },
            {
                path: '/login',
                name: 'Login',
                component: () => import('@/views/pages/Login.vue'),
                meta: {
                    public: true
                }
            },
            {
                path: '/blog/:slug',
                name: 'Blog',
                component: () => import('@/views/windows/paginas/VerPost.vue'),
                meta: {
                    public: true
                }
            },
            {
                path: '/ayuda/:slug',
                name: 'Ayuda',
                component: () => import('@/views/windows/paginas/VerPostAyuda.vue'),
                meta: {
                    public: true
                }
            },
            /*{
                path: '/reset-password',
                name: 'ResetPassword',
                component: () => import('@/views/pages/RecuperarPass.vue'),
                meta: {
                    public: true
                }
            },*/
            /*{
                path: '/reset-my-password/:token',
                name: 'ResetPasswordWToken',
                component: () => import('@/views/pages/RecuperarPass.vue'),
                meta: {
                    public: true
                }
            },*/
            {
                path: '/auth/manager',
                name: 'AuthManager',
                component: () => import('@/views/pages/AuthManager'),
                meta: {
                    public: true
                }
            },
            /*{
                path: '/register',
                name: 'Register',
                component: () => import('@/views/pages/Register'),
                meta: {
                    public: true
                }
            },
            ,*/
        ],
    },
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        // always scroll to top
        return {top: 0}
    },
})

/**
 * Determina el access requerido por la ruta
 */
function getRequiredAccess(to) {
    const matched = to.matched.slice().reverse();
    for (const record of matched) {
        if (record && record.meta && record.meta.access) {
            return record.meta.access;
        }
    }
    return null;
}

router.beforeEach((to, from, next) => {
    const rutaPublica = to.matched.some(record => record.meta.public);

    if (to.path === '/404' || to.path === '/login' || rutaPublica) {
        next();
        return;
    }

    store.dispatch('ValidateLogin', {
        callback: (response) => {
            // Sin sesión válida: al login
            if (!response || typeof response.logged === 'undefined') {
                next('/login');
                return;
            }

            if (!store.getters.authLogged) {
                window.location.href = '/#/login';
                return;
            }

            // Rutas que no exigen permiso específico siguen libres.
            const requiredAccess = getRequiredAccess(to);
            if (!requiredAccess) {
                next();
                return;
            }

            // Mitigación 8.txt RevMit01: NO confiar en `response.m` a secas.
            // Un atacante puede interceptar /auth/validate-login con un proxy
            // (Burp/ZAP) e inyectar claves admin en `m`. Antes de renderizar,
            // re-validamos contra /auth/can-access que verifica HMAC sobre
            // `m` y reconsulta los permisos server-side como autoridad final.
            const token   = (response && response.token) ? response.token : '';
            const userM   = (response && response.m && typeof response.m === 'object') ? response.m : {};
            const userSig = (response && typeof response.mSig === 'string') ? response.mSig : '';

            fetch(config.backendUrl + '/auth/can-access', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token,
                },
                body: JSON.stringify({
                    key: requiredAccess,
                    m: userM,
                    mSig: userSig,
                }),
            })
                .then(r => r.json())
                .then(payload => {
                    const allowed = !!(payload && payload.status && payload.data && payload.data.allowed);
                    if (allowed) {
                        next();
                    } else {
                        next({path: '/panel', replace: true});
                    }
                })
                .catch(() => {
                    // Falla de red o de servidor: por seguridad denegamos.
                    next({path: '/panel', replace: true});
                });
        }
    });
});

export default router
